
export default {
  name: 'CardValues',
  props: {
    products: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    Purchase() {
      this.$router.push(
        `/${this.$normalizeAndLowercaseString(this.products.nome)}`
      )
    },
    moreInformationProduct() {
      this.$router.push(`/saiba-mais/${this.products.nome}`)
    },
  },
}
